"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _keyOrIndexToProperty = _interopRequireDefault(require("./keyOrIndexToProperty"));

var _default = function _default(key) {
  return function (parcelData) {
    var property = (0, _keyOrIndexToProperty["default"])(key)(parcelData);

    if (typeof property === "undefined") {
      return undefined;
    }

    if (typeof property !== "number") {
      throw new Error("Cannot find index on non-indexed parcelData");
    }

    return property;
  };
};

exports["default"] = _default;